import React from "react";

interface InputFieldInterface {
  register?: any;
  validate?: any;
  defaultValue?: any;
  placeHolder?: any;
  type?: string;
  value?: any;
  name?: string;
  disabled?: boolean;
  currency?: boolean;
  erros?: any;
  width?: number;
  maxLegth?: number;
}

export const InputField = ({
  register,
  validate,
  defaultValue,
  placeHolder,
  type = "text",
  value,
  name,
  disabled,
  erros,
  width,
  maxLegth,
}: InputFieldInterface) => {
  const isValid = (nextValue: string) => {
    return typeof validate === "function"  ? validate(nextValue) : true ;
  };

  const buildNextValue = (input: HTMLInputElement, insertedValue: string) => {
    const currentValue = input.value || "";
    const selectionStart =
      input.selectionStart !== null ? input.selectionStart : currentValue.length;
    const selectionEnd =
      input.selectionEnd !== null ? input.selectionEnd : currentValue.length;

    return (
      currentValue.slice(0, selectionStart) +
      insertedValue +
      currentValue.slice(selectionEnd)
    );
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (!validate) {
      return;
    }

    const controlKeys = [
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "ArrowUp",
      "ArrowDown",
      "Tab",
      "Home",
      "End",
      "Enter",
      "Escape",
    ];

    if (
      e.ctrlKey ||
      e.metaKey ||
      e.altKey ||
      controlKeys.includes(e.key)
    ) {
      return;
    }

    if (e.key.length !== 1) {
      return;
    }

    const nextValue = buildNextValue(e.currentTarget, e.key);
    if (!isValid(nextValue)) {
      e.preventDefault();
    }
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    if (!validate) {
      return;
    }

    const pastedData = e.clipboardData.getData("text");
    const nextValue = buildNextValue(e.currentTarget, pastedData);

    if (!isValid(nextValue)) {
      e.preventDefault();
    }
  };

  return (
    <div
      className={`input clientForm__control input-field m-0 ${
        width === 50 && "w-50"
      }`}
    >
      <input
        id={name}
        name={name}
        ref={register && validate ? register(validate) : register}
        defaultValue={defaultValue}
        maxLength={maxLegth}
        type={type}
        disabled={disabled}
        onKeyDown={validate ? handleKeyDown : undefined}
        onPaste={validate ? handlePaste : undefined}
      />
      <label className={defaultValue ? "active" : "false"} htmlFor={name}>
        {placeHolder}
      </label>
    </div>
  );
};
